import React, { useEffect, useState } from 'react';
import { Card, InputNumber, Select, Table, Tag } from 'antd';
import { useLeave } from '../../hooks/useLeave';
import { useEmployees } from '../../hooks/useEmployees';

const { Option } = Select;

const LeaveBalanceView: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const [selectedEmployee, setSelectedEmployee] = useState<number | null>(null);
  const [year, setYear] = useState(currentYear);
  const { leaveBalances, fetchLeaveBalances } = useLeave();
  const { employees, fetchEmployees } = useEmployees();

  useEffect(() => { fetchEmployees(); }, []);
  useEffect(() => {
    if (selectedEmployee) fetchLeaveBalances(selectedEmployee, year);
  }, [selectedEmployee, year]);

  const columns = [
    { title: 'Leave Type', dataIndex: 'leaveTypeName', key: 'leaveTypeName' },
    { title: 'Year', dataIndex: 'year', key: 'year', width: 70 },
    { title: 'Entitled', dataIndex: 'entitledDays', key: 'entitledDays', width: 80 },
    { title: 'Carried Over', dataIndex: 'carriedOverDays', key: 'carriedOverDays', width: 100 },
    { title: 'Taken', dataIndex: 'takenDays', key: 'takenDays', width: 70 },
    { title: 'Pending', dataIndex: 'pendingDays', key: 'pendingDays', width: 80 },
    {
      title: 'Remaining', dataIndex: 'remainingDays', key: 'remainingDays', width: 90,
      render: (n: number) => <Tag color={n > 0 ? 'green' : 'red'}>{n}</Tag>,
    },
  ];

  return (
    <div className="p-6">
      <Card title="Leave Balances">
        <div className="flex gap-4 mb-4">
          <Select
            placeholder="Select employee"
            showSearch
            optionFilterProp="children"
            style={{ width: 280 }}
            onChange={setSelectedEmployee}
          >
            {employees.map((e) => (
              <Option key={e.id} value={e.id}>{e.firstName} {e.lastName} ({e.employeeNumber})</Option>
            ))}
          </Select>
          <InputNumber
            min={2020} max={2040} value={year}
            onChange={(v) => v && setYear(v)}
            style={{ width: 100 }}
          />
        </div>
        <Table dataSource={leaveBalances} columns={columns} rowKey="id" size="small" pagination={false} />
      </Card>
    </div>
  );
};

export default LeaveBalanceView;
